<template>
<v-container id="main">
  <v-row style="display: block;">
    <v-col align="center">
      <div id="cards" style="display: block; width: 100%; height: 100% !important;">
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <p class="mt-12"> 1 Cube Bin = 1 Bakkie </p>
              <img src="@/assets/1cube to 1bakkie.svg" alt="Avatar" style="width:300px; height:300px; margin-top: -2.5cm;">
            </div>
            <div class="flip-card-back">
              <p class="pt-10 mx-2"> A 1 ton Bakkie load is approximately 1 <br/>
                  cube or 1 ton. So a 6 cube bin take 6 <br/>
                  one ton bakkie loads of normal density waste. 
              </p>
              <p class="mx-2"> Handle your waste once in your own time <br/> 
                  We leave the bin for 7 days. You load and we <br/>
                  remove when you order a collection or exchange. 
              </p>
            </div>
          </div>
        </div>
        <br/>
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <p class="mt-12"> 1 Cube Truck = 1 Bakkie  </p>
              <img src="@/assets/1cube truck to 1bakkie.svg" alt="Avatar" style="width:300px; height:300px; margin-top: -2.5cm;"> 
            </div>
            <div class="flip-card-back">
              <p class="pt-10 mx-2">A 1 ton bakkie load is approximately 1 cube or 1 ton.
                So a 6 cube truck takes 6 one ton bakkie loads of normal density waste.
              </p>
            </div>
          </div>
        </div>
        <br/>
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <p class="mt-12"> 1000 Liters = 1 Bakkie </p>
              <img src="@/assets/1000liters to 1bakkie.svg" alt="Avatar" style="width:300px; height:300px; margin-top: -2.5cm;">
            </div>
            <div class="flip-card-back">
              <p class="pt-10 mx-2"> A 1 ton bakkie load is approximately 1000 liters. </p>
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: 'tonnage',
}
</script>

<style scoped>

.flip-card {
  background-color: transparent;
  width: 100%;
  height: 400px;
  perspective: 1000px;
  border-radius: 50px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  -webkit-transition: transform 0.6s;
  transition: transform 0.6s;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  box-shadow: 0 34px 38px 0 #101B24;
  border-radius: 24px;
}

.flip-card:hover .flip-card-inner {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background-color: white;
  color: #101B24;
  border-radius: 24px;
  border: 1px solid black;
}

.flip-card-back {
  background-color: #1B2C37;
  color: white;
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
  border-radius: 24px;
}
@media only screen and (max-width: 850px){
  #cards{
  display: block;
  flex-wrap: wrap;

}
.flip-card {
  margin-bottom: 1cm;
}
}
@media only screen and (max-width: 580px){
  .flip-card{
    width: 100%;
    height: 350px;
  }
  #cards{
  display: block;
  margin-left: -0.32cm;

}
}
</style>